<template>
  <div class="page-box">
    <p class="title">扫描结果</p>
    <div class="item">
      <p v-if="orderDetail.detail" class="name">{{ orderDetail.detail.purchaser }}的退货单</p>
      <p v-if="orderDetail" class="info">退货商品：{{ getProduct(orderDetail.itemList) }}</p>
      <p v-if="orderDetail.detail" class="info">申请日期：{{ getTime(orderDetail.detail.refundTime) }}</p>
    </div>
    <p class="title">受理服务点</p>
    <div class="item fuwudian">
      <div class="header">
        <div class="location">
          <img src="../../../assets/refund/icon_ locationPoint@2x.png" alt="">
          <span>{{ seleceServicePoint.centerName || '无' }}</span>
        </div>
        <div v-if="userInfo && userInfo.roleList[0] !== 'CenterHandler'" class="xuanze" @click="servicePointHandle">
          <span>重新选择</span>
          <van-icon color="#36B374" name="arrow" />
        </div>
      </div>
      <p class="info">{{ seleceServicePoint.address || '无' }}</p>
    </div>
    <van-button @click="associate" class="guanlian" color="#36B374">关联</van-button>
    <list
      ref="servicePointPicker"
      @select="selectServicePointHandle"
      @close="selectServicePointHandle"
      :datalist="servicePointData"
      :header="'选择受理服务点'" />
  </div>
</template>

<script>
    import { vm } from '../../../main';
    import api from '../../../service/modules/refund';
    import util from '../../../utils/common';
    import list from '../views/components/ListservicePoint'

    export default {
        components: { list },
        data () {
            return {
                // flowId: '8a8885eb7d4bb1e9017d4c11a26a0060'
                flowId: '2c288a107bed698d017bed8b8d55000f',
                orderDetail: {},
                servicePointData: [], // 服务点列表
                servicePointPickerShow: false, // 服务点弹框显示
                seleceServicePoint: {
                },
                userInfo: {
                    roleList: []
                }
            };
        },
        async beforeRouteEnter (to, from, next) {
            try {
                console.log(111)
                const flowId = to.query.flowId
                let orderDetail = {}
                let role
                let seleceServicePoint
                // 获取角色
                const currentUserRes = await api.currentUser()
                role = currentUserRes.data.roleList[0]
                const userInfo = currentUserRes.data
                console.log('userInfo', userInfo)
                // 获取详情
                const detailRes = await api.detailList({ flowId })
                if (detailRes.ret === 0) {
                    orderDetail = detailRes.data
                    const param = {
                        basicId: orderDetail.detail.basicId
                    }
                    api.listRelevance(param).then(res => {
                        const servicePointData = res.data.filter(i => i.address)

                        for (let i = 0; i < servicePointData.length; i++) {
                            if (role == 'CenterHandler') {
                                if (servicePointData[i].isCurRefund) {
                                    seleceServicePoint = servicePointData[i]
                                    break
                                }
                            }
                        }
                        // 如果是退货中心直接关联退货单
                        if (role == 'CenterHandler') {
                            const param = {
                                flowId: flowId,
                                serviceId: seleceServicePoint.id,
                                serviceName: seleceServicePoint.centerName,
                                centerType: seleceServicePoint.centerType
                            }
                            api.relevance(param).then(res => {
                                if (res.ret === 0) {
                                    vm.$toast('关联退货单成功')
                                    next(vm => {
                                        vm.$router.push({
                                            path: '/refund/refundDetail',
                                            query: {
                                                flowId: flowId
                                            }
                                        })
                                    })
                                } else {
                                    vm.$router.back()
                                }
                            })
                        } else {
                            // 不是退货中心的话就跳转关联退货单页面
                            next()
                        }
                    })
                }
            } catch (err) {
                alert(err)
            }
        },
        created () {
            this.flowId = this.$route.query.flowId
            this.getorderDetail();
            this.currentUser()
        },
        methods: {
            currentUser () {
                api.currentUser().then(res => {
                    if (res.ret === 0) {
                        this.userInfo = res.data
                    } else {
                        this.userInfo = {}
                    }
                })
            },
            // 点击服务点回调
            selectServicePointHandle (item) {
                this.seleceServicePoint = item;
            },
            // 打开服务点弹框
            servicePointHandle () {
                this.$refs['servicePointPicker'].init(this.seleceServicePoint);
            },
            servicePointList () {
                let basicId
                if (this.orderDetail && this.orderDetail.detail) {
                    basicId = this.orderDetail.detail.basicId
                    const param = {
                        basicId
                    }
                    api.listRelevance(param).then(res => {
                        if (res.ret === 0) {
                            
                            this.servicePointData = res.data.filter(i => i.address)

                            for (let i = 0; i < this.servicePointData.length; i++) {
                                // 如果是退货中心取isCurRefund为true的值
                                if (this.userInfo && this.userInfo.roleList[0] == 'CenterHandler') {
                                    if (this.servicePointData[i].isCurRefund) {
                                        this.seleceServicePoint = this.servicePointData[i]
                                        break
                                    }
                                }
                                // 如果是监理中心取isCurUser为true的值
                                if (this.userInfo && this.userInfo.roleList[0] == 'Handler') {
                                    if (this.servicePointData[i].isCurUser) {
                                        this.seleceServicePoint = this.servicePointData[i]
                                        break
                                    }
                                }
                            }
                        }
                    })
                }
            },
            associate () {
                const param = {
                    flowId: this.flowId,
                    serviceId: this.seleceServicePoint.id,
                    serviceName: this.seleceServicePoint.centerName,
                    centerType: this.seleceServicePoint.centerType
                };
                api.relevance(param).then(res => {
                    if (res.ret === 0) {
                        if (res.msg) {
                            this.$toast.success(res.msg);
                            setTimeout(() => {
                                this.$router.push({
                                    path: '/refund/refundDetail',
                                    query: {
                                        flowId: this.flowId
                                    }
                                });
                            }, 1500);
                        } else {
                            this.$toast('暂未找到退货单');
                        }
                    } else {
                        // this.$toast(res.msg);
                    }
                });
            },
            getTime (val) {
                return util.getStampInDateDay(val);
            },
            getProduct (list) {
                const proList = [];
                if (list && list.length > 0) {
                    list.map(i => {
                        proList.push(i.itemName);
                    });
                }
                return proList.join(',');
            },
            getorderDetail () {
                const param = {
                    flowId: this.flowId
                };
                api.detailList(param).then(res => {
                    if (res.ret === 0) {
                        this.orderDetail = res.data;
                        this.servicePointList()
                    } else {
                        this.orderDetail = {};
                    }
                });
            }
        }
    };
</script>

<style lang="less" scoped>
.page-box {
  background-color: #f8f9fc;
  min-height: 100vh;
  padding: 16px 12px 0 12px;
  .title {
    font-size: 12px;
    color: #9da0a4;
    font-weight: 400;
    margin-bottom: 8px;
  }
  .item {
    background-color: white;
    padding: 14px 16px 16px 16px;
    margin-bottom: 16px;
    .name {
      font-size: 16px;
      color: #171a1d;
      font-weight: 400;
      margin-bottom: 6px;
    }
    .info {
      font-size: 12px;
      color: #71747a;
      font-weight: 400;
      &:not(:last-child) {
        margin-bottom: 5px;
      }
    }
  }
  .fuwudian {
    .header {
      display: flex;
      justify-content: space-between;
      .location {
        display: flex;
        align-items: center;
        img {
          width: 18px;
          height: 18px;
        }
        span {
          font-size: 16px;
          color: #333333;
          font-weight: 500;
        }
      }
      .xuanze {
        display: flex;
        align-items: center;
        .van-icon-arrow:before {
            font-size: 12px;
        }
        span {
          font-size: 14px;
          color: #36B374;
          font-weight: 500;
          margin-right: 3px;
        }
      }
    }
    .info {
      font-size: 12px;
      color: #999999;
      font-weight: 400;
      margin-top: 10px;
      line-height: 20px;
    }
  }
  .guanlian {
    width: 100%;
    border-radius: 4px;
    margin-top: 20px;
  }
}
</style>
